module.exports = __webpack_public_path__ + "static/media/Img-05.c20bf45f.jpg";